/* Neglbutikk – «Få e-post når varen er tilbake» (Klaviyo Back in Stock, ingen app) */
(function () {
  'use strict';
  if (window.NBBis) return;
  window.NBBis = true;

  var KLAVIYO_KEY = 'VipyAD';
  var STORE = 'nb_bis_v1';
  var email = (window.NB_CUSTOMER_EMAIL || '').trim();
  var ICON = '<svg class="wl-bis__icon" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 6.5 8.5 6.5 8.5-6.5"/></svg>';

  function done() { try { return JSON.parse(localStorage.getItem(STORE) || '{}'); } catch (e) { return {}; } }
  function markDone(v, mail) { try { var d = done(); d[v] = mail; localStorage.setItem(STORE, JSON.stringify(d)); } catch (e) {} }
  function validEmail(s) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(s); }

  function subscribe(variantId, mail) {
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_KEY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: {
        profile: { data: { type: 'profile', attributes: { email: mail } } }, channels: ['EMAIL'] },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } } } })
    }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error('HTTP ' + r.status); });
  }

  var product = null, box = null, lastVariant = null;

  function currentVariantId(form) {
    var inp = form && form.querySelector('[name="id"]');
    var v = inp && (inp.value || inp.getAttribute('value'));
    if (!v) { var m = /[?&]variant=(\d+)/.exec(location.search); v = m && m[1]; }
    return v ? String(v) : null;
  }

  function render(variantId) {
    var v = null;
    for (var i = 0; i < product.variants.length; i++) if (String(product.variants[i].id) === variantId) v = product.variants[i];
    if (!v) v = product.variants[0];
    if (v.available) { box.hidden = true; return; }
    box.hidden = false;
    var sent = done()[String(v.id)];
    if (sent) {
      box.innerHTML = '<div class="wl-bis__ok">' + ICON + '<span>Vi sender deg en e-post' + (sent !== '1' ? ' til <strong>' + esc(sent) + '</strong>' : '') + ' når varen er tilbake på lager.</span></div>';
      return;
    }
    box.innerHTML =
      '<button type="button" class="wl-bis__btn" data-bis-open>' + ICON + '<span>Få e-post når varen er tilbake</span></button>' +
      '<form class="wl-bis__form" data-bis-form hidden novalidate>' +
        '<p class="wl-bis__lead">Skriv inn e-posten din, så gir vi beskjed så snart varen er på lager igjen.</p>' +
        '<div class="wl-bis__row"><input type="email" name="email" placeholder="Din e-post" autocomplete="email" required value="' + esc(email) + '">' +
        '<button type="submit" class="wl-bis__send">Gi meg beskjed</button></div>' +
        '<p class="wl-bis__err" data-bis-err hidden></p>' +
      '</form>';
    var open = box.querySelector('[data-bis-open]');
    var form = box.querySelector('[data-bis-form]');
    var err = box.querySelector('[data-bis-err]');
    function send(mail, btn) {
      if (!validEmail(mail)) { err.textContent = 'Skriv inn en gyldig e-postadresse.'; err.hidden = false; form.hidden = false; return; }
      err.hidden = true;
      btn.disabled = true;
      var label = btn.querySelector('span') || btn;
      var old = label.textContent;
      label.textContent = 'Sender…';
      subscribe(String(v.id), mail).then(function () {
        markDone(String(v.id), mail);
        render(String(v.id));
      }).catch(function () {
        btn.disabled = false; label.textContent = old;
        err.textContent = 'Noe gikk galt. Prøv igjen om litt.'; err.hidden = false; form.hidden = false;
      });
    }
    open.addEventListener('click', function () {
      if (email && validEmail(email)) { send(email, open); return; }   /* innlogget: ett klikk */
      open.hidden = true; form.hidden = false;
      var inp = form.querySelector('input'); if (inp) inp.focus();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      send(form.querySelector('input').value.trim(), form.querySelector('.wl-bis__send'));
    });
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function init() {
    var form = document.querySelector('[data-section-type="product"] form[action*="/cart/add"][data-product-handle]') ||
               document.querySelector('form[action*="/cart/add"][data-product-handle]');
    if (!form) return;
    var handle = form.getAttribute('data-product-handle');
    var anchor = form.closest('.product__block__buttons') || form.parentNode;
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        product = p;
        if (p.variants.every(function (x) { return x.available; })) return;
        box = document.createElement('div');
        box.className = 'wl-bis';
        box.hidden = true;
        var wish = anchor.querySelector('[data-wl-product-mounted]');
        anchor.insertBefore(box, wish || null);
        var tick = function () {
          var id = currentVariantId(form);
          if (id && id !== lastVariant) { lastVariant = id; render(id); }
        };
        tick();
        form.addEventListener('change', function () { setTimeout(tick, 50); });
        document.addEventListener('click', function () { setTimeout(tick, 120); });
        setInterval(tick, 800);
      }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
